import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

// Settings
export const getSettings = () => api.get('/settings').then(r => r.data);
export const updateSettings = (data) => api.put('/settings', data).then(r => r.data);

// Registrations
export const createRegistration = (data) => api.post('/registrations', data).then(r => r.data);
export const getRegistrations = () => api.get('/registrations').then(r => r.data);

// Contacts
export const createContact = (data) => api.post('/contacts', data).then(r => r.data);

// Cypha Kings Registrations
export const submitCyphaKingsRegistration = (data) => api.post('/cypha-kings/register', data).then(r => r.data);
export const getCyphaKingsRegistrations = () => api.get('/cypha-kings/registrations').then(r => r.data);

// Fuori per il Cash Newsletter
export const submitFuoriCashNewsletter = (data) => api.post('/fuori-cash/newsletter', data).then(r => r.data);
export const getFuoriCashNewsletters = () => api.get('/fuori-cash/newsletters').then(r => r.data);

// Profiles
export const getProfiles = () => api.get('/profiles').then(r => r.data);
export const createProfile = (data) => api.post('/profiles', data).then(r => r.data);
export const updateProfile = (id, data) => api.put(`/profiles/${id}`, data).then(r => r.data);
export const deleteProfile = (id) => api.delete(`/profiles/${id}`).then(r => r.data);

// Products
export const getProducts = () => api.get('/products').then(r => r.data);
export const createProduct = (data) => api.post('/products', data).then(r => r.data);

// Gallery
export const getGallery = () => api.get('/gallery').then(r => r.data);
export const addGalleryImage = (data) => api.post('/gallery', data).then(r => r.data);
export const deleteGalleryImage = (id) => api.delete(`/gallery/${id}`).then(r => r.data);

// Freestylers
export const getFreestylers = () => api.get('/freestylers').then(r => r.data);
export const getPendingFreestylers = () => api.get('/freestylers/pending').then(r => r.data);
export const getAllFreestylers = () => api.get('/freestylers/all').then(r => r.data);
export const createFreestyler = (data) => api.post('/freestylers', data).then(r => r.data);
export const updateFreestyler = (id, data) => api.put(`/freestylers/${id}`, data).then(r => r.data);
export const approveFreestyler = (id) => api.put(`/freestylers/${id}/approve`).then(r => r.data);
export const rejectFreestyler = (id) => api.put(`/freestylers/${id}/reject`).then(r => r.data);
export const deleteFreestyler = (id) => api.delete(`/freestylers/${id}`).then(r => r.data);

// Grammar check
export const checkGrammar = (text) => api.post('/grammar-check', { text }).then(r => r.data);

// Sponsors
export const getSponsors = () => api.get('/sponsors').then(r => r.data);

// File upload
export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export default api;
